module.exports = __webpack_public_path__ + "assets/retina_ATrByCircumcenterDetailed.aec2284ed80e94c56e39b34a6fe8c3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_ATrByCircumcenterDetailed.png
// module id = 610
// module chunks = 0